import React from 'react'
import styled from 'styled-components'
import { AnimatedSection, fadeInUp } from './animations/AnimatedSection'

const PartnerWithUsSection = () => {
  return (
    <Section>
      <ContentStack>
        <AnimatedSection variants={fadeInUp}>
          <Title>Partner with us</Title>
        </AnimatedSection>
        <AnimatedSection variants={fadeInUp} delay={0.15}>
          <CTAButton>Get Involved</CTAButton>
        </AnimatedSection>
      </ContentStack>
    </Section>
  )
}

const Section = styled.section`
  position: relative;
  width: 100%;
  height: 480px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    url('/images/homepage-new/mountain.webp');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  @media (max-width: 768px) {
    height: 400px;
    padding: 0 24px;
  }
`

const ContentStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  max-width: 600px;
  text-align: center;
`

const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  line-height: 64px;
  letter-spacing: -0.04em;
  color: #f8f7f0;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 40px;
    line-height: 48px;
  }
`

const CTAButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 24px;
  width: 195px;
  height: 52px;
  background: #ffffff;
  border: 1px solid #2a2a2a;
  border-radius: 100px;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #2a2a2a;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  letter-spacing: 0px;

  &:hover {
    background: #f8f7f0;
    transform: translateY(-2px);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
`

export default PartnerWithUsSection
